import { MutationTuple, useMutation } from '@apollo/client';

import { MergeRdProjectsMutation, MergeRdProjectsMutationVariables, MERGE_RD_PROJECTS } from '@neo.tax/shared';

export const useMergeRdProjectsMutation = (): MutationTuple<
  MergeRdProjectsMutation,
  MergeRdProjectsMutationVariables
> => {
  const mutation = useMutation<MergeRdProjectsMutation, MergeRdProjectsMutationVariables>(MERGE_RD_PROJECTS);

  return mutation;
};
